import { createElement, Fragment } from 'react';
import type { ReactNode } from 'react';
import type { AxisTick } from '../Axis/Axis.types';
import type { SingleAxisProps } from '../AxisAndGrid.types';
import { formatNumericTicks } from '../../../js/helpers/number-helpers/numberHelpers';
import { convertToZonedTimestamp } from '../../../js/helpers/date-helpers/dateHelpers';
import { toNumberTimestamp } from '../../../util.js';

export const formatTickLabels = (ticks: AxisTick[], { scale_type, time_zone }: Pick<SingleAxisProps, 'scale_type' | 'time_zone'>): ReactNode[] => {
  if (scale_type === 'linear') {
    const labels = formatNumericTicks(ticks.map(tick => Number(tick.value)));
    return ticks.map((tick, index) => tick.value === undefined ? tick.label : labels[index]);
  }
  if (scale_type === 'time') {
    const times = ticks.map(tick => toNumberTimestamp(tick.value));
    const daily = times.every(time => time === undefined || convertToZonedTimestamp(time, time_zone, 'HH:mm') === '00:00');
    if (daily) return ticks.map((tick, index) => {
      const time = times[index];
      return time === undefined ? tick.label : convertToZonedTimestamp(time, time_zone, 'axis');
    });
    let previous_date: string | undefined;
    let previous_clock: string | undefined;
    return ticks.map((tick, index) => {
      const time = times[index];
      if (time === undefined) return tick.label;
      const date = convertToZonedTimestamp(time, time_zone, 'axis');
      const clock = convertToZonedTimestamp(time, time_zone, 'p');
      const is_same_date = date === previous_date;
      const is_same_clock = is_same_date && clock === previous_clock;
      previous_date = date;
      previous_clock = clock;
      if (is_same_clock) return '';
      return createElement(Fragment, null,
        createElement('span', { className: 'html-axis-tick__start' }, is_same_date ? '\u00a0' : date),
        createElement('span', { className: 'html-axis-tick__end' }, clock));
    });
  }
  return ticks.map(tick => tick.value === undefined ? tick.label : String(tick.value));
};
